import { useState } from 'react';

import Block from '@mui/icons-material/Block';
import { Grid, Typography } from '@mui/material';
import { Button, useNotify, useRefresh, useUpdate, Confirm, useRecordContext, HttpError } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { HttpErrorTypography } from 'src/lib';
import { UserDetails } from 'src/models';

export const CloseUserActionButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const record = useRecordContext<UserDetails>();

  const notify = useNotify();
  const refresh = useRefresh();
  const [update, { isLoading, isError, error, reset }] = useUpdate<UserDetails, HttpError>();

  const onConfirm = async () => {
    update(
      DataProviderResource.CloseUser,
      {
        id: record.id,
      },
      {
        onSuccess: () => {
          notify('User successfully closed.', { type: 'success' });
          onClose();
        },
        onSettled: () => {
          refresh();
        },
      },
    );
  };

  const onClose = () => {
    setIsOpen(false);
    reset();
  };

  return (
    <>
      <Button label='Close' onClick={() => setIsOpen(true)} disabled={isLoading} style={{ marginTop: '8px' }}>
        <Block />
      </Button>
      <Confirm
        isOpen={isOpen}
        loading={isLoading}
        title='Close user'
        content={
          <Grid container direction='column' spacing={2}>
            <Grid item md={12} sm={12}>
              <Typography variant='body1'>Are you sure you want to close user?</Typography>
              {isError && <HttpErrorTypography error={error} />}
            </Grid>
          </Grid>
        }
        onConfirm={onConfirm}
        onClose={onClose}
      />
    </>
  );
};
